<template>
  <div class="login">
    <div class="login-box">
      <div class="login-top">
        <img src="../../assets/image/logo5.jpg" alt />
        <p>{{ loginTitle }}</p>
      </div>
      <!-- 登录表单区域 -->
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginFormRules"
        label-width="60px"
        class="login_form"
      >
        <el-form-item
          v-if="showDevEnvSwitcher"
          label="环境"
          class="dev-env-item"
        >
          <el-select
            size="small"
            v-model="devEnvKey"
            placeholder="选择后端环境"
            @change="onDevEnvChange"
          >
            <el-option
              v-for="item in devApiEnvs"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
          <div class="dev-env-tip">{{ currentApiHint }}</div>
        </el-form-item>
        <el-form-item label="商户" prop="userType">
          <el-select
            size="small"
            @change="userTypeChange"
            v-model="loginForm.userType"
            placeholder="请选择商户类型"
            clearable
          >
            <el-option label="工厂" :value="0"></el-option>
            <el-option label="门店" :value="4"></el-option>
            <el-option label="供应商" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- 用户名 -->
        <el-form-item v-if="dialogFactory" label="工厂" prop="factoryType">
          <el-select
            ref="optionRef"
            size="small"
            v-model="loginForm.factoryType"
            placeholder="请选择所在工厂"
          >
            <el-option
              v-for="item in factoryList"
              :key="item.id"
              :label="item.addrName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 用户名 -->
        <el-form-item label="账号" prop="username">
          <el-input
            prefix-icon="el-icon-user"
            v-model="loginForm.username"
            placeholder="请输入用户名"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item label="密码" prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item class="btn">
          <el-button type="primary" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<style lang="less" scoped>
.login {
  // background-color: #fcf7e0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    width: 550px;
    min-height: 420px;
    height: auto;
    padding-bottom: 24px;
    position: relative;
    box-shadow: 0 0 10px #ccc;
    background-color: #fff;

    // 头像样式
    .login-top {
      text-align: center;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50px;
        border: 2px solid #fcf7e0;
        box-shadow: 0 0 10px #ccc;
        margin: 20px 0;
      }
    }
    // 表单样式
    .login_form {
      width: 85%;
      margin: 0 auto;
      padding: 0 50px 10px;
      box-sizing: border-box;

      .btn {
        .el-button {
          width: 100%;
        }
      }
    }
  }
}
.dev-env-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.3;
  word-break: break-all;
}
</style>
<script>
import { goLogin, getToken } from "@/api/api.js";
import { setCookie, getCookie } from "@/unit/cookie";
// 获取所有工厂
import { getFactoryAll } from "@/api/order.js";
// 通过用户名查询用户
import { loadUserByUserName } from "@/api/power.js";
// 门店管理查询授权门店
import { selectManageStage } from "@/api/point.js";
import axios from "axios";
import user from "@/store/modules/user";
import {
  API_BASE_URL,
  DEPLOY_NAME,
  DEV_API_ENVS,
  CURRENT_DEV_ENV_KEY,
  REMOTE_API_BASE_URL,
  setDevApiEnv,
} from "@/config/api";
import { LOGIN_TITLE } from "@/config/app";
export default {
  data() {
    const matched = DEV_API_ENVS.find((item) => item.key === CURRENT_DEV_ENV_KEY);
    return {
      loginTitle: LOGIN_TITLE,
      showDevEnvSwitcher: process.env.NODE_ENV !== "production",
      devApiEnvs: DEV_API_ENVS,
      devEnvKey: CURRENT_DEV_ENV_KEY || (matched && matched.key) || "xq",
      currentApiHint: `${DEPLOY_NAME} → 代理 → ${REMOTE_API_BASE_URL}`,
      // 这是登录表单的数据绑定对象
      loginForm: {
        // 工厂选择
        factoryType: null,
        userType: null,
        username: "",
        password: "",
      },
      // 是否显示工厂选项
      dialogFactory: false,
      // 工厂列表
      factoryList: [],
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          {
            min: 3,
            max: 11,
            message: "长度在 3 到 11 个字符",
            trigger: "blur",
          },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur",
          },
        ],
        // 验证是否选择工厂
        factoryType: [
          { required: true, message: "请选择工厂", trigger: "blur" },
        ],
        // 验证是否选择商户
        userType: [{ required: true, message: "请选择商户", trigger: "blur" }],
      },
    };
  },
  created() {
    let userT = Number(getCookie("userType"));
    //页面加载完全局监听键盘事件，然后调用函数
    this.getFactory(userT);
    document.addEventListener("keyup", this.watchEnter);
  },
  destroyed() {
    //页面跳转销毁全局监听事件
    document.removeEventListener("keyup", this.watchEnter);
  },
  methods: {
    onDevEnvChange(key) {
      const ok = setDevApiEnv(key);
      if (!ok) {
        this.$message.error("切换环境失败");
        return;
      }
      // 清登录态，避免串环境 token
      window.sessionStorage.clear();
      localStorage.removeItem("stageArr");
      localStorage.removeItem("labelArr");
      localStorage.removeItem("channelArr");
      this.$message.success("已切换环境，页面即将刷新");
      setTimeout(() => {
        window.location.reload();
      }, 400);
    },
    // 点击登录按钮，验证表单的用户名和密码
    async login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        let data = {
          username: this.loginForm.username,
          password: this.loginForm.password,
        };
        // console.log(valid); 布尔值
        if (!valid) return;
        const { data: res } = await goLogin(data);
        if (res.code === 200) {
          setCookie("factoryId", this.loginForm.factoryType, 3);
          if (this.loginForm.userType == 0) {
            let factoryName = this.$refs.optionRef.selected.label;
            setCookie("factoryName", factoryName, 3);
          }
          // console.log(typeof this.loginForm.factoryType);
          // 将登录成功之后的token，保存到客户端的sessionStorage中
          // 项目中除了登录之外的其他API接口，必须在登录之后才能访问
          // token 只应在当前网站打开期间生效，所以将token 保存在sessionStorage中
          setCookie("username", this.loginForm.username, 3);
          setCookie("password", this.loginForm.password, 3);
          window.sessionStorage.setItem("getToken", res.data);
          // 获取用户ID、用户昵称、用户供应商ID
          loadUserByUserName(data.username, this.loginForm.userType).then(
            (users) => {
              console.log("loadUser1111", users);
              if (users.data.code === 200) {
                if (users.data.data) {
                  this.$message.success("登录成功!");
                  getToken().then((response) => {
                    window.sessionStorage.setItem("token", response.data.data);
                    // 通过编程式导航跳转到后台主页，路由地址是 /
                    this.$router.push({ path: "/" });
                    console.log("token", response);
                  });
                  setCookie("userId", users.data.data.id, 3);
                  setCookie("type", users.data.data.type, 3);
                  setCookie("nickname", users.data.data.nickname, 3);
                  setCookie("supplierId", users.data.data.supplierId, 3);
                  setCookie("channelId", users.data.data.channelId, 3);
                  setCookie("userType", users.data.data.userType, 3);

                  // 通过门店管理登录的进行绑定门店查询
                  if (this.loginForm.userType === 4) {
                    this.getManageStage(users.data.data.id);
                  }
                } else {
                  return this.$message.warning(`商户类型选择错误!!!`);
                }
              } else {
                return this.$message.error(`${users.data.message}`);
              }
            },
          );
        } else {
          return this.$message.error("登录失败!");
        }
      });
    },
    // 门店登录获取所绑门店
    async getManageStage(userId) {
      const { data: res } = await selectManageStage(userId);
      if (res.code === 200) {
        let data = res.data || [];
        localStorage.setItem("stageArr", JSON.stringify(data));
        console.log("门店", data);
      }
    },
    watchEnter(e) {
      //按键判断：e.which返回当前按键的键值，然后if判断键值是否等于13,13是回车键的键值。如果是调用登录请求
      let keyNum = e.which;
      if (keyNum == 13) {
        this.login();
      }
    },
    userTypeChange(val) {
      if (val == 0) {
        this.getFactory(val);
      } else {
        this.dialogFactory = false;
      }
    },
    // 获取工厂列表
    async getFactory(type) {
      let factoryCook = Number(getCookie("factoryId"));
      let userType = type;
      if (userType == 3) {
        this.dialogFactory = false;
        this.loginForm.userType = 3;
      } else {
        this.dialogFactory = true;
        this.loginForm.userType = 0;
        try {
          const { data: res } = await getFactoryAll();
          if (res.code === 200) {
            this.factoryList = res.data;
            if (factoryCook && res.data.length != 0) {
              this.loginForm.factoryType = factoryCook;
            } else if (res.data.length == 1) {
              this.loginForm.factoryType = res.data[0].id;
            } else {
              this.loginForm.factoryType = res.data[0].id || "";
            }
          }
        } catch (e) {
          this.$message.error("获取工厂列表失败，请检查网络或切换环境");
        }
      }
    },
  },
};
</script>
